import { Menu } from "@headlessui/react";
import classNames from "classnames";
import React from "react";

import Icon, { Icons } from "../../../../common/Icon/Icon";

import styles from "./DropdownItem.module.css";

interface Props {
    onClick?: () => void;
    isActive?: boolean;
    icon: Icons;
    title?: string;
    children: React.ReactNode;
}

const DropdownItem = ({ onClick, isActive, title, children, icon }: Props) => (
    <Menu.Item as="li">
        {({ active }) => {
            const cn = classNames(styles.MenuItem, {
                [styles.MenuItemActive]: isActive || active,
            });

            return (
                <button onClick={onClick} title={title} type="button" className={cn}>
                    {children}
                    <Icon icon={icon} />
                </button>
            );
        }}
    </Menu.Item>
);

export default DropdownItem;
